import { convertDateToUTC } from './convertDateToUTC';

export function createStringDateWithoutTimezone(date: string | Date) {
  return convertDateToUTC(date).toISOString().slice(0, 16);
}

export function createStringDateUTCWithoutTimezone(date: Date) {
  return date.toISOString().slice(0, 16);
}
